export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-thumbnail-v1-480-60415f75f12207c35d32cc3a344226ca.webp";